import ProductSearchCss from "../../../pages/product-search-page/product-search.module.css";
import { Trans } from "@coworker/locales";

interface SearchNoResultsProps {
  searchQuery: string;
}

export const SearchNoResults = ({ searchQuery }: SearchNoResultsProps) => {
  return (
    <div className={ProductSearchCss["no-results"]}>
      <div className={ProductSearchCss["no-results-header"]}>
        <Trans>noTaskResultsString</Trans>
      </div>
      <span className={ProductSearchCss["no-results-description"]}>
        <Trans values={{ query: searchQuery }}>
          noSearchResultsForQueryString
        </Trans>
      </span>
    </div>
  );
};
